import { Center, Grid, Loader, Notification, Title } from '@mantine/core'
import { useDocumentTitle } from '@mantine/hooks'
import { useQuery } from '@tanstack/react-query'
import { createRoute, Link } from '@tanstack/react-router'
import { useMemo } from 'react'
import { Temporal } from 'temporal-polyfill'
import { LocationsShowingMovie } from '../components/locations_showing_movie.tsx'
import { MovieCard } from '../components/movie_card.tsx'
import { trpc } from '../queryClient.ts'
import { rootRoute } from '../root.tsx'
import { formatFullDate, groupMoviesByDate } from '../tools/dates.ts'
import { useErrorNotifier } from '../tools/errors.tsx'

export const savedMoviesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/saved',
  component: SavedMovies,
})

function SavedMovies() {
  useDocumentTitle('Mewview Watchcat - Saved movies')

  return (
    <div>
      <Title pb="sm">Saved movies</Title>
      <UpcomingMoviesList/>
    </div>
  )
}

function UpcomingMoviesList() {
  const { data: movies, isLoading, error } = useQuery(trpc.movie.all.queryOptions({ saved: true }))
  useErrorNotifier('Error fetching saved movies', error)

  const dateAndMovies = useMemo(() => Object.entries(groupMoviesByDate(movies)).sort(), [movies])

  if (isLoading) return <Center h="100px"><Loader type="dots"/></Center>
  if (error) {
    return (
      <Notification withCloseButton={false} title="An error occurred fetching upcoming movies" color="red">
        {error.message}
      </Notification>
    )
  }

  if (!dateAndMovies?.length) {
    return <div>No saved movies. Check out <Link to="/">what's in cinemas</Link>.</div>
  }
  return dateAndMovies.map(([date, moviesOnDate]) => (
    <div key={date}>
      <Title mt="xl" mb="md" order={2}>{date ? formatFullDate(Temporal.PlainDate.from(date)) : 'Unknown'}</Title>
      <Grid gutter={{ base: 'xs', sm: 'md', md: 'lg' }}>
        {(moviesOnDate || []).map(movie => (
          <Grid.Col span={{ xs: 12, sm: 6 }} key={movie.id}>
            <MovieCard movie={movie}>
              <LocationsShowingMovie movieTimes={movie.times}/>
            </MovieCard>
          </Grid.Col>
        ))}
      </Grid>
    </div>
  ))
}
